"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const theme_1 = __importStar(require("@atlaskit/theme"));
const emotion_theming_1 = require("emotion-theming");
const ThemeContext = react_1.default.createContext({
    mode: "light"
});
exports.ThemeContextConsumer = ThemeContext.Consumer;
class ThemeContextProvider extends react_1.default.Component {
    render() {
        const { mode, children } = this.props;
        return (react_1.default.createElement(emotion_theming_1.ThemeProvider, { theme: (theme) => (Object.assign(Object.assign({}, theme), { __ATLASKIT_THEME__: { mode } })) },
            react_1.default.createElement(theme_1.default.Provider, { value: (current, props) => current(Object.assign(Object.assign({}, props), { mode })) },
                react_1.default.createElement(theme_1.AtlasKitThemeProvider, { mode: mode },
                    react_1.default.createElement(ThemeContext.Provider, { value: { mode } }, children)))));
    }
}
exports.ThemeContextProvider = ThemeContextProvider;
function withTheme(WrapperComponent) {
    const ThemeWrapper = props => (react_1.default.createElement(exports.ThemeContextConsumer, null, theme => react_1.default.createElement(WrapperComponent, Object.assign({}, props, { theme: theme }))));
    ThemeWrapper.displayName = WrapperComponent.displayName;
    return ThemeWrapper;
}
exports.withTheme = withTheme;
exports.useTheme = () => {
    const theme = react_1.useContext(ThemeContext);
    return theme;
};
